import useScreenSize from "../hooks/useScreenSize";

export default function GuestStories() {
  const { isMobile, isTablet } = useScreenSize();

  const reviews = [
    {
      name: "Rahul S.",
      stay: "Business Traveller",
      review:
        "The apartment genuinely felt like home during my three-week stay. The staff were incredibly helpful, the Wi-Fi was reliable for work, and the location made commuting around Whitefield effortless.",
    },
    {
      name: "Sarah M.",
      stay: "Family Stay",
      review:
        "Beautifully maintained apartments with thoughtful amenities. The kitchenette, housekeeping, and peaceful atmosphere made our family holiday comfortable and stress-free.",
    },
    {
      name: "Aditya K.",
      stay: "Extended Stay",
      review:
        "I've stayed in several serviced apartments across Bengaluru, and Ebenezer stands out for its cleanliness, hospitality, and exceptional value for longer stays.",
    },
  ];

  return (
    <section
      style={{
        background: "#EFE8DD",
        padding: isMobile ? "80px 20px" : "120px 32px",
      }}
    >
      <div
        style={{
          maxWidth: 1300,
          margin: "0 auto",
        }}
      >
        {/* Heading */}

        <div
          style={{
            textAlign: "center",
            marginBottom: isMobile ? 50 : 80,
          }}
        >
          <p
            style={{
              color: "#C9A66B",
              letterSpacing: ".16em",
              fontFamily: "'JetBrains Mono', monospace",
              fontSize: isMobile ? 12 : 14,
            }}
          >
            GUEST STORIES
          </p>

          <h2
            style={{
              fontFamily: "'Fraunces', serif",
              fontSize: isMobile ? 36 : isTablet ? 44 : 52,
              color: "#222",
              margin: "18px 0",
              lineHeight: 1.15,
            }}
          >
            Experiences worth sharing.
          </h2>

          <p
            style={{
              maxWidth: 700,
              margin: "0 auto",
              color: "#666",
              lineHeight: 1.8,
              fontSize: isMobile ? 16 : 18,
            }}
          >
            Every stay leaves behind a story. Here are a few moments
            shared by our guests.
          </p>
        </div>

        {/* Reviews */}

        <div
          style={{
            display: "grid",
            gap: isMobile ? 24 : 40,
          }}
        >
          {reviews.map((review, index) => (
            <div
              key={index}
              style={{
                background: "#FFF",
                padding: isMobile ? 30 : isTablet ? 45 : 60,
                border: "1px solid #DDD7CC",
                position: "relative",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: isMobile ? 12 : 25,
                  left: isMobile ? 18 : 35,
                  fontSize: isMobile ? 60 : 90,
                  color: "#EFE8DD",
                  fontFamily: "'Fraunces', serif",
                  lineHeight: 1,
                }}
              >
                “
              </div>

              <p
                style={{
                  fontSize: isMobile ? 18 : isTablet ? 21 : 24,
                  lineHeight: 1.9,
                  color: "#444",
                  position: "relative",
                  zIndex: 2,
                  maxWidth: 900,
                  margin: isMobile
                    ? "25px auto 35px"
                    : "40px auto 50px",
                  fontStyle: "italic",
                }}
              >
                {review.review}
              </p>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                  gap: 12,
                }}
              >
                <h3
                  style={{
                    fontFamily: "'Fraunces', serif",
                    color: "#222",
                    margin: 0,
                    fontSize: isMobile ? 22 : 28,
                  }}
                >
                  {review.name}
                </h3>

                <p
                  style={{
                    color: "#888",
                    margin: 0,
                    fontSize: isMobile ? 14 : 16,
                  }}
                >
                  {review.stay}
                </p>

                <div
                  style={{
                    color: "#C9A66B",
                    fontSize: isMobile ? 18 : 24,
                    letterSpacing: 4,
                  }}
                >
                  ★★★★★
                </div>
              </div>              
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}